import request from 'api/request';

export default function schoolIndexRoute() {
  return request({ url: '/schools' });
}
